import { useState } from 'react';

export default function useOrders(getOrdersQuery: any) {
	const [page, setPage] = useState(1);
	const getOrders = (filter: object) => {
		getOrdersQuery({
			filter: filter,
			skip: (page - 1) * 20,
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return { getOrders, getNextPage, page, setPage };
}
